import React from "react";
import { Col, Form, Row } from 'react-bootstrap';
import NumberEditor from "common/ui/NumberEditor";
import Contract, { ContractSplit } from "domain/contract";
import CustomerAccountPicker from "features/settings/producers/CustomerAccountPicker";
import LocationPicker from "features/locations/LocationPicker";
import { ErpSystem } from "domain/erpSystem";
import Merchant from "domain/merchant";
import useMappedLocations from "features/locations/mappings/useMappedLocations";

interface SplitDetailsProps {
    contract: Contract;
    activeMerchant: Merchant;
    splits: ContractSplit[];
    onSplitChanged(split: ContractSplit): void;
    onRemove(split: ContractSplit): void;
}

const SplitDetails: React.FC<SplitDetailsProps> = props => {

    const mappedLocations = useMappedLocations();

    return <div className="split-details">{props.splits?.map(split => {

        const mappedLocationResult = mappedLocations.getOptions(split.deliveryLocation?.id, split.inventoryLocation?.id);

        return <div key={split.id}>
        <Form.Group as={Row}>
                <Form.Label column>Split</Form.Label>
                <Col xs="4">
                    <div className="col-form-label">#{split.id}</div>
                </Col>
                <Col xs="4" className="text-right">
                    <button className='link-button mr-auto' onClick={() => props.onRemove(split)}>
                        <span className="fa fa-trash"></span>
                    </button>
                </Col>
            </Form.Group>

            <Form.Group as={Row}>
                <Form.Label column>Quantity</Form.Label>
                <Col xs="8">
                    <NumberEditor
                        aria-label="Quantity"
                        required
                        allowDecimals   
                        enforcePrecision
                        thousandSeparator
                        unit={props.contract.commodity.baseUnit.abbreviation}
                        min={0}
                        value={split.quantity}
                        onValueChange={value => props.onSplitChanged({ ...split, quantity: value })}
                        validationName="quantity"
                        isInvalidMessage={"Please enter a valid quantity"}
                        type="text"
                    />
                </Col>
            </Form.Group>

            {props.activeMerchant.erpSystem === ErpSystem.AgrisDataHub && <Form.Group as={Row}>
                <Form.Label column></Form.Label>
                <Col xs="8">
                    <Form.Check
                        value={split.id}
                        label="Use Unapplied Balance"
                        checked={split.useUnappliedBalance}
                        onChange={ev => props.onSplitChanged({ ...split, useUnappliedBalance: ev.target.checked })} 
                    />
                </Col>
            </Form.Group>}

            <Form.Group as={Row}>
                <Form.Label column>Acct ID/Customer</Form.Label>
                <Col xs="8">
                    <CustomerAccountPicker
                        showClearButton
                        inputProps={{ required: true, 'aria-label': "Customer" }}
                        onCustomerSelected={(c, a) => props.onSplitChanged({ ...split, producer: c, customerAccount: a })}
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row}>
                <Form.Label column>Delivery Location</Form.Label>
                <Col xs="8">
                   <LocationPicker
                    required
                    locations={mappedLocationResult.deliveryLocations}
                    selected={split.deliveryLocation}
                    onLocationSelected={l => props.onSplitChanged({ ...split, deliveryLocation: l })}
                />
                </Col>
            </Form.Group>

            {props.activeMerchant.generalSettings.displayInventoryLocation && <Form.Group as={Row} className="border-bottom pb-3">
                <Form.Label column>Inventory Location</Form.Label>
                <Col xs="8">
                   <LocationPicker
                    required
                    locations={mappedLocationResult.inventoryLocations}
                    selected={split.inventoryLocation}
                    onLocationSelected={l => props.onSplitChanged({ ...split, inventoryLocation: l })}
                />
                </Col>
            </Form.Group>}
        </div>
    })}</div>;
}

export default SplitDetails;
